import {React, useEffect, useState} from "react";
import { Link, useLocation } from "react-router-dom";
import "./Menu.css";
import "../../index.css";
import $ from "jquery"
import { Search, ListNested, List, Heart, HeartFill, UiChecksGrid } from 'react-bootstrap-icons';
import MudaPagina from "../Util/Navegacao";
import ItensProdutos from "./ItensProdutos";
import Impressao from "./Impressao";
import { LocalData } from "../Util/LocalData";
import HorarioAtendimento from "../HorarioAtendimento";

const Menu = () => {
    const [localdataPROD, setLocaldataPROD] = useState("");
    const [busca, setBusca] = useState("");
    const location = useLocation();


    useEffect(() => {
        const MarcadorMenu = async (e) => {      
            $("#objCarregaTela").addClass("display-block");  
            try{   
                if(LocalData.get("prodID") !== "")
                    setLocaldataPROD(JSON.parse(LocalData.get("prodID")));
            }catch(error){}

            const { hash, pathname, search } = location;
            let raiz = location.pathname.split("/")[1];
            //console.log("raiz", raiz, location.pathname);
            if(location.pathname === "/" || location.pathname === "/home") {
                $(".itensMenu li").removeClass("marcador");
                $(".inicio").addClass("marcador");
            } else {
                //console.log($(".itensMenu li"));
                $(".itensMenu li").removeClass("marcador");
                $("."+raiz).addClass("marcador");
            }

            try{
            //ao carregar a página, atualiza o contador de items da lista de desejos
                AtualizaContador(JSON.parse(LocalData.get("prodID")));
            } catch(error){}

            //$("header .subMenu").hide();
            $("#objCarregaTela").removeClass("display-block");  
        }
        MarcadorMenu();
    }, [location]);

    window.onscroll = function() {myFunction()};
    function myFunction() {
        if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
            //document.getElementById("menu").className = "test";
            $(".header-principal").addClass("scroll");
        } else {
            //document.getElementById("menu").className = "";
            $(".header-principal").removeClass("scroll");
        }

        // if(document.body.scrollTop > 400 || document.documentElement.scrollTop > 400){
        //     $(".vitrine .ItensProdutos").addClass("fixo");
        // }else{
        //     $(".vitrine .ItensProdutos").removeClass("fixo");
        // }
    }

    window.onresize = function(){
        // console.log(window.innerWidth, window.outerWidth);
        // if(window.innerWidth > 767 && $(".itensMenu").hasClass("menu-mobile"))
        //     $("body").removeClass("overflow-hidden");
        // else if(window.innerWidth <= 767 && $(".itensMenu").hasClass("menu-mobile"))
        //     $("body").addClass("overflow-hidden");
        // else
        //     $("body").removeClass("overflow-hidden");
        if(window.innerWidth > 767){
            $(".itensMenu").removeClass("menu-mobile");
            //$("body").removeClass("overflow-hidden");
            $(".fundo-ativo").removeClass("display-block");
        }

    }

    const EvClickMobile = (e)=>{
        //e.stopPropagation();
        //e.preventDefault();
        $(".itensMenu").toggleClass("menu-mobile");      
        if($(".itensMenu").hasClass("menu-mobile"))
            $("body").addClass("overflow-hidden");
        else
            $("body").removeClass("overflow-hidden");

        $(".fundo-ativo").addClass("display-block")
        .off().on("click", (e)=>{
            e.stopPropagation();
            // alert("teste");
            $(".itensMenu").removeClass("menu-mobile");
            $(e.currentTarget).removeClass("display-block");
            $("body").removeClass("overflow-hidden");
        });
    }

    const evCliqueListaDesejos = (e) =>
    {
        $(".area-impressao-produto").addClass("selecionado");
        $(".area-produto").removeClass("produto-selecionado");
        // $("body").addClass("overflow-hidden");

        $(".itensMenu").toggleClass("menu-mobile");      
        if($(".itensMenu").hasClass("menu-mobile"))
            $("body").addClass("overflow-hidden");
        else
            $("body").removeClass("overflow-hidden");

        $(".itensMenu").removeClass("menu-mobile");
        $(".fundo-ativo").trigger("click");
        
        try{
        if(LocalData.get("prodID") !== "")
            setLocaldataPROD(JSON.parse(LocalData.get("prodID")));
        }catch(error){}
    }

    const evCliqueBuscarProduto = () =>{
        MudaPagina(`/Produtos?sr=${$("#buscaProd").val()}`);
    }


    function AtualizaContador(lista){
        if(lista.length > 0) {
            $(".lista-de-desejos").addClass("marcador");
        } else {
            $(".lista-de-desejos").removeClass("marcador");    
        }      
        $(".lista-de-desejos .contador").html(lista.length);
        LocalData.set("prodID", JSON.stringify(lista));
    }      
    return (
        <>
            {/* <HorarioAtendimento></HorarioAtendimento> */}
            <header className="header-principal">
                <div className="menu conteudo">
                    <div className="cabecalho">
                        <img onClick={() => MudaPagina("/")} className="logo" src="/lgCM.svg" />
                        <div className="itensMenu area-mobile-menu">
                            <div className="mobile-menu lista-de-desejos" onClick={evCliqueListaDesejos}>
                                <div className="area-icone">
                                    <div className="contador">0</div>
                                    <HeartFill size={24}></HeartFill>
                                </div>
                                {/* <span>Meu catálogo</span> */}
                            </div>
                        </div>
                        <div className="mobile-menu icon-mobile" onClick={EvClickMobile}>
                            <List size={30} />
                        </div>
                        <ul className="desktop-menu itensMenu conteudo">
                            <li className="inicio" onClick={() => MudaPagina("/home")} ><h3>HOME</h3></li>
                            <li className="btn-produtos produtos" onClick={() => MudaPagina("/produtos")} ><h3><UiChecksGrid size={24} style={{"paddingRight":"5px", "marginTop": "-5px !important"}}></UiChecksGrid>CATÁLOGO</h3>
                                <ItensProdutos classCSS={"mobile-menu"}></ItensProdutos>
                            </li>
                            <li className="clientes" onClick={() => MudaPagina("/clientes")}><h3>CLIENTES</h3></li>
                            <li className="quem-somos" onClick={() => MudaPagina("/quem-somos")}><h3>QUEM SOMOS</h3></li>
                            <li className="eventos" onClick={() => MudaPagina("/eventos")}><h3>EVENTOS</h3></li>
                            <li className="contato" onClick={() => MudaPagina("/contato")}><h3>CONTATO</h3></li>
                            <li className="lista-de-desejos" onClick={evCliqueListaDesejos}>
                                <div className="area-icone">
                                    <div className="contador">0</div>
                                    <HeartFill size={24}></HeartFill>
                                </div>
                                <span>Meu catálogo</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="fundo-ativo"></div>
                <div className="area-busca-produtos">
                <div className="conteudo">
                    <div className="campo-busca">
                        <input id="buscaProd" type="search" placeholder="Digite sua busca" />
                        <div className="btn-buscar-produto" onClick={evCliqueBuscarProduto}>
                            <Search size={20}></Search>
                        </div>
                    </div>
                </div>
            </div>            
            </header>
            {/* <HorarioAtendimento /> */}            
            <Impressao Lista={localdataPROD} AtualizaContador={AtualizaContador}></Impressao>
        </>
    );
}
export default Menu;